module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch04"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Good Taste Contest")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The husband and wife were competing in a Good Taste Contest judged by a jury of their peers, men and women of good taste, including a fabric designer, a rare-book dealer, a pastry cook, and a librarian. The wife was judged to have better taste in furniture, especially antique furniture. The husband was judged to have overall poor taste in lighting fixtures, tableware, and glassware. The wife was judged to have indifferent taste in window treatments, but the husband and wife both were judged to have good taste in floor coverings, bed linen, bath linen, large appliances, and small appliances. The husband was felt to have good taste in carpets, but only fair taste in upholstery fabrics. The husband was felt to have very good taste in both food and alcoholic beverages, while the wife had inconsistently good to poor taste in food. The husband had better taste in clothes than the wife though inconsistent taste in perfumes and colognes. While both husband and wife were judged to have no more than fair taste in garden design, they were judged to have good taste in number and variety of evergreens. The husband was felt to have excellent taste in roses but poor taste in bulbs. The wife was felt to have better taste in bulbs and generally good taste in shade plantings with the exception of hostas. The husband’s taste was felt to be good in garden furniture but only fair in ornamental planters. The wife’s taste was judged consistently poor in garden statuary. After a brief discussion, the judges gave the decision to the husband for his higher overall points score.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bbf13cf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781466806276_ch04.vue
// module id = 84
// module chunks = 0